import React from "react";
import { connect } from "react-redux";
import { Segment, Header, Button } from "semantic-ui-react";
import FormNuevoContacto from "./ventasNuevaPersonaContacto/FormNuevoContacto";
import TablaContactos from "./ventasNuevaPersonaContacto/TablaContactos";
import { ventasContactosOps } from "../../ducks/ventasContactos";

class VentasNuevaPersonaContacto extends React.Component {
  state = {
    visibleFormNuevo: false,
    editPersonaContacto: null
  };

  componentDidMount() {
    this.props.attachListenersPersonasContacto(
      this.props.match.params.idColegio
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.dataSaved.status) {
      this.props.resetDataSaved();
    }
  }

  componentWillUnmount() {
    this.props.quitarColegioSeleccionado();
    this.props.limpiarPersonasContacto();
    this.props.detachListenersPersonasContacto();
  }

  handleVolver = () => this.props.history.goBack();

  handleMostrarFormulario = () =>
    this.setState(state => ({ visibleFormNuevo: true }));

  handleAddContacto = values => {
    this.props.addPersonaContacto({
      ...values,
      idColegio: this.props.match.params.idColegio,
      nombreColegio: "",
      uid: this.props.user.uid,
      nombreUsuario: this.props.user.displayName || this.props.user.email,
      forma_principal: false,
      isEdit: this.state.editPersonaContacto !== null
    });
    this.setState(state => ({
      visibleFormNuevo: false,
      editPersonaContacto: null
    }));
  };

  handleDescartar = () => this.setState(state => ({ visibleFormNuevo: false }));

  handleBorrarPersonaContacto = idPersona =>
    this.props.borrarPersonaContacto({ idPersona });

  handleEditPersonaContacto = idPersona =>
    this.setState(state => ({
      visibleFormNuevo: true,
      editPersonaContacto: this.props.personasContacto.filter(
        ({ id }) => id === idPersona
      )[0]
    }));

  handleDefaultPersonaContacto = idPersona =>
    this.props.esContactoPrincipal({
      idColegio: this.props.match.params.idColegio,
      idPersona
    });

  render() {
    const { colegioSeleccionado, personasContacto } = this.props;
    return (
      <Segment>
        <Segment basic>
          <Button
            content="Cerrar"
            floated="right"
            color="pink"
            icon="cancel"
            onClick={this.handleVolver}
          />
          <Header
            as="h3"
            content={colegioSeleccionado && colegioSeleccionado.nombreColegio}
          />
        </Segment>

        <Segment basic>
          <Button
            content="Añadir Persona de Contacto"
            color="pink"
            icon="add"
            disabled={this.state.visibleFormNuevo}
            onClick={this.handleMostrarFormulario}
          />
          {this.state.visibleFormNuevo && (
            <Segment>
              <FormNuevoContacto
                handleAddContacto={this.handleAddContacto}
                handleDescartar={this.handleDescartar}
                initialValues={this.state.editPersonaContacto}
              />
            </Segment>
          )}
        </Segment>
        <Segment>
          <Header as="h3" content="Personas de Contacto" />
          <TablaContactos
            datos={personasContacto}
            handleBorrarPersonaContacto={this.handleBorrarPersonaContacto}
            handleEditPersonaContacto={this.handleEditPersonaContacto}
            handleDefaultPersonaContacto={this.handleDefaultPersonaContacto}
          />
        </Segment>
      </Segment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.session.user,
  dataSaved: state.ventasContactos.dataSaved,
  colegioSeleccionado: state.ventas.colegioSeleccionado,
  personasContacto: state.ventasContactos.personasContacto
});

const mapDispatchToProps = {
  addPersonaContacto: ventasContactosOps.addPersonaContacto,
  quitarColegioSeleccionado: ventasContactosOps.quitarColegioSeleccionado,
  resetDataSaved: ventasContactosOps.resetDataSaved,
  limpiarPersonasContacto: ventasContactosOps.limpiarPersonasContacto,
  attachListenersPersonasContacto:
    ventasContactosOps.attachListenersPersonasContacto,
  detachListenersPersonasContacto:
    ventasContactosOps.detachListenersPersonasContacto,
  borrarPersonaContacto: ventasContactosOps.borrarPersonaContacto,
  esContactoPrincipal: ventasContactosOps.esContactoPrincipal
};

export default connect(mapStateToProps, mapDispatchToProps)(
  VentasNuevaPersonaContacto
);



// WEBPACK FOOTER //
// ./src/pages/ventas/VentasNuevaPersonaContacto.jsx